<template>
  <div style="position: relative; width:960px">
    <el-breadcrumb separator=""
                   style="margin-top: 12px">
      <el-breadcrumb-item>开发支持</el-breadcrumb-item>
      <el-breadcrumb-item><img src="../assets/icon-bread-arrow.svg"
             alt=""></el-breadcrumb-item>
      <el-breadcrumb-item>位置描述</el-breadcrumb-item>
    </el-breadcrumb>
    <anchor class="title-wrap"
            style="width:150px">
      <anchor-link href="#id-product-introduction"
                   title="产品介绍" />
      <anchor-link href="#id-application-scene"
                   title="适用场景" />
      <anchor-link href="#id-instructions-for-use"
                   title="使用说明" />
      <anchor-link href="#id-keyword-location"
                   title="位置描述" />
      <anchor-link href="#id-keyword-location"
                   title="位置描述" />
    </anchor>
    <div id="content-containter"
         style="width: 788px;">
      <h1>位置描述</h1>
      <span class="time">最后更新时间：2022年01月10日</span>
      <h2 id="id-product-introduction">产品介绍</h2>
      <ul>
        <li>
          <p>
            位置描述API是通过HTTP协议访问远程服务的接口，提供结构化地址与经纬度之间相互转化的服务。 </p>
        </li>
      </ul>
      <h2 id="id-application-scene">适用场景</h2>
      <p>
      <ul>
        <li>
          <p>
            位置描述：将经纬度转换为详细结构化的地址，且返回附近周边的POI信息，以及该经纬度所在的POI信息。<br>例如：116.498655,40.005333→北京市朝阳区望京东路1号
          </p>
        </li>
      </ul>
      </p>
      <h2 id="id-instructions-for-use">使用说明</h2>
      <p>
      <ul>
        <li>第一步，申请Web服务API类型Key；</li>
        <li>第二步，参考接口文档发起HTTP/HTTPS请求；</li>
        <li>第三步，接收请求返回的JSON数据。</li>
      </ul>
      </p>
      <h2 id="id-keyword-location">位置描述</h2>
      <h3>
        <ul style="list-style-type:disc;list-style-position:inside;">
          <li>位置描述API服务地址</li>
        </ul>
      </h3>
      <div class="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>
                <p>URL</p>
              </th>
              <th>
                <p>https://lbsapi.meituan.com/v1/location/regeo?parameters</p>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <p>请求方式</p>
              </td>
              <td>
                <p>GET</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <h3 id="id-request-params">
        <ul style="list-style-type:disc;list-style-position:inside;">
          <li>请求参数</li>
        </ul>
      </h3>
      <div class="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>
                <p><strong>参数名</strong></p>
              </th>
              <th width="90">
                <p><strong>数据类型</strong></p>
              </th>
              <th width="138">
                <p><strong>含义</strong></p>
              </th>
              <th>
                <p><strong>规则说明</strong></p>
              </th>
              <th width="88">
                <p><strong>是否必填</strong></p>
              </th>
              <th width="70">
                <p><strong>缺省值</strong></p>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <p>key</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>请求服务权限标识</p>
              </td>
              <td>
                <p>用户申请到的Web服务API Key</p>
              </td>
              <td>
                <p>是</p>
              </td>
              <td>
                <p>无</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>location</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>经纬度坐标</p>
              </td>
              <td>
                <p>
                  经纬度间以“,”分割，经纬度小数点后不得超过6位，“lng,lat”经度在前，纬度在后
                </p>
              </td>
              <td>
                <p>是</p>
              </td>
              <td>
                <p>无</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>radius</p>
              </td>
              <td>
                <p>int</p>
              </td>
              <td>
                <p>搜索半径</p>
              </td>
              <td>
                <p>取值范围：0~200,单位：米<br>小于0：按照50米计算<br>大于200：按照200米计算</p>
              </td>
              <td>
                <p>否</p>
              </td>
              <td>
                <p>50</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>show_fields</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>返回结果控制</p>
              </td>
              <td>
                <p>
                  <font data-size="14"
                        style="font-size:14px;line-height:22px">show_fields用来筛选response结果中的可选字段。<br>show_fields使用规则如下：<br>1、可指定返回字段<br>
                    <ul style="list-style-type:disc;list-style-position:inside;">
                      <li>base</li>
                      <li>admin</li>
                      <li>poi</li>
                      <li>aoi</li>
                      <li>businessarea</li>
                      <li>streetnumber</li>
                    </ul><br>2、多个字段间采用“|”进行分割；<br>3、show_fields未设置时，默认为base，返回formatted_address
                  </font>
                </p>
              </td>
              <td>
                <p>否</p>
              </td>
              <td>
                <p>无</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <h3 id="id-返回结果参数说明">
        <ul style="list-style-type:disc;list-style-position:inside;">
          <li>返回结果参数说明</li>
        </ul>
      </h3>
      <div class="table-wrapper">
        <table>
          <thead>
            <tr>
              <th colspan="6">
                <p><strong>名称</strong></p>
              </th>
              <th>
                <p><strong>数据类型</strong></p>
              </th>
              <th>
                <p><strong>含义</strong></p>
              </th>
              <th>
                <p><strong>规则说明</strong></p>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="6">
                <p>status</p>
              </td>
              <td>
                <p>int</p>
              </td>
              <td>
                <p>返回结果状态值</p>
              </td>
              <td>
                <p>
                  200为成功；其它为失败，失败原因请参阅
                  <router-link :to="'/support/status'"
                               style="color: #1890ff;">状态码说明</router-link>
                  。
                </p>
              </td>
            </tr>
            <tr>
              <td colspan="6">
                <p>msg</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>状态描述</p>
              </td>
              <td>
                <p> 当status不是200时，msg会返回具体错误原因，否则返回“成功”。详情参阅
                  <router-link :to="'/support/status'"
                               style="color: #1890ff;">状态码说明</router-link>
                </p>

              </td>
            </tr>
            <tr>
              <td colspan="6">
                <p>regeocode</p>
              </td>
              <td>
                <p>struct</p>
              </td>
              <td>
                <p>位置描述信息</p>
              </td>
              <td>
                <p>结果对象列，包括下述字段：</p>
              </td>
            </tr>
            <tr>
              <td rowspan="38">
                <p></p>
              </td>
              <td colspan="5">
                <p>formatted_address</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>结构化地址信息</p>
              </td>
              <td>
                <p>返回AOI/POI的中第一个的结果。
                在此必须特别说明，此字段的设计初衷是让业务方能够快速理解经纬度对应的地址信息（例如：北京市朝阳区小关街道北四环东路安徽大厦），但当前此字段设计不合理，仅仅返回一个AOI/POI名称（例如：安徽大厦）。如需获取地址信息，可使用行政区划相关字段拼接而成。</p>
              </td>
            </tr>
            <tr>
              <td colspan="5">
                <p>country</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>国家</p>
              </td>
              <td>
                <p>例如：中国</p>
              </td>
            </tr>
            <tr>
              <td colspan="5">
                <p>province</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>地址所在的省份名</p>
              </td>
              <td>
                <p>
                  例如：北京市。此处需要注意的是，中国的四大直辖市、特别行政区也算作省级单位。
                </p>
              </td>
            </tr>
            <tr>
              <td colspan="5">
                <p >pcode</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>省份行政编码</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td colspan="5">
                <p>city</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>地址所在的城市名</p>
              </td>
              <td>
                <p>例如：北京市</p>
              </td>
            </tr>
            <tr>
              <td colspan="5">
                <p >citycode</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>城市行政编码</p>
              </td>
              <td>
                <p>例如：110100</p>
              </td>
            </tr>
            <tr>
              <td colspan="5">
                <p >areacode</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>区号</p>
              </td>
              <td>
                <p>例如：010</p>
              </td>
            </tr>
            <tr>
              <td colspan="5">
                <p>district</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>地址所在的区</p>
              </td>
              <td>
                <p>例如：朝阳区</p>
              </td>
            </tr>
            <tr>
              <td colspan="5">
                <p>adcode</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>区域编码</p>
              </td>
              <td>
                <p>例如：110101</p>
              </td>
            </tr>
            <tr>
              <td colspan="5">
                <p>township</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>坐标点所在乡镇/街道（此街道为社区街道，不是道路信息）</p>
              </td>
              <td>
                <p>例如：奥运村街道</p>
              </td>
            </tr>
            <tr>
              <td colspan="5">
                <p>towncode</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>乡镇街道编码</p>
              </td>
              <td>
                <p>例如：110101001000</p>
              </td>
            </tr>
            <tr>
              <td colspan="5">
                <p>street_number</p>
              </td>
              <td>
                <p>entity</p>
              </td>
              <td>
                <p>门牌信息列表</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td rowspan="2">
                <p></p>
              </td>
              <td colspan="4">
                <p>street</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>街道名称</p>
              </td>
              <td>
                <p>例如：中关村北二条</p>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                <p>number</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>门牌号</p>
              </td>
              <td>
                <p>例如：3号</p>
              </td>
            </tr>
            <tr>
              <td colspan="5">
                <p>business_areas</p>
              </td>
              <td>
                <p v-text="'object'"></p>
              </td>
              <td>
                <p>经纬度所属商圈列表</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td rowspan="8">
                <p></p>
              </td>
               <td colspan="4">
                <p>inside_business_areas</p>
              </td>
              <td>
                <p v-text="'array<inside_business_area>'"></p>
              </td>
              <td>
                <p>请求点在内部的商圈</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td rowspan="3">
                <p></p>
              </td>
              <td colspan="3">
                <p>inside_business_area</p>
              </td>
              <td>
                <p v-text="'object'"></p>
              </td>
              <td>
                <p></p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td rowspan="2">
                <p></p>
              </td>
              <td colspan="2">
                <p>location</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>商圈中心点经纬度</p>
              </td>
              <td>
                <p>格式：lng,lat</p>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <p>name</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>商圈名称</p>
              </td>
              <td>
                <p>例如：颐和园</p>
              </td>
            </tr>

            <tr>
               <td colspan="4">
                <p>nearby_business_areas</p>
              </td>
              <td>
                <p v-text="'array<nearby_business_area>'"></p>
              </td>
              <td>
                <p>请求点在外部的商圈</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td rowspan="3">
                <p></p>
              </td>
              <td colspan="3">
                <p>nearby_business_area</p>
              </td>
              <td>
                <p v-text="'object'"></p>
              </td>
              <td>
                <p></p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td rowspan="2">
                <p></p>
              </td>
              <td colspan="2">
                <p>location</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>商圈中心点经纬度</p>
              </td>
              <td>
                <p>格式：lng,lat</p>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <p>name</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>商圈名称</p>
              </td>
              <td>
                <p>例如：颐和园</p>
              </td>
            </tr>
            <tr>
              <td colspan="5">
                <p>pois</p>
              </td>
              <td>
                <p v-text="'array<poi>'"></p>
              </td>
              <td>
                <p>POI信息</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td rowspan="8">
                <p></p>
              </td>
              <td colspan="4">
                <p>poi</p>
              </td>
              <td>
                <p>entity</p>
              </td>
              <td>
                <p></p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td rowspan="7">
                <p></p>
              </td>
              <td colspan="3">
                <p>id</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>POI的ID</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <p>name</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>POI点名称</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <p>type</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>POI类型</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <p>distance</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>该POI的中心点到请求坐标的距离</p>
              </td>
              <td>
                <p>单位：米</p>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <p>direction</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>方向</p>
              </td>
              <td>
                <p>为输入点相对建筑物的方位</p>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <p>address</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>POI地址信息</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <p>location</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>坐标点</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td colspan="5">
                <p>aois</p>
              </td>
              <td>
                <p v-text="'array<aoi>'"></p>
              </td>
              <td>
                <p>AOI信息</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td rowspan="5">
                <p></p>
              </td>
              <td colspan="4">
                <p>aoi</p>
              </td>
              <td>
                <p>entity</p>
              </td>
              <td>
                <p></p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td rowspan="4">
                <p></p>
              </td>
              <td colspan="3">
                <p>id</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>所属AOI的id</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <p>name</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>所属AOI名称</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <p>location</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>所属AOI代表点坐标 lng,lat</p>
              </td>
              <td>
                <p></p>
              </td>
            </tr>
            <tr>
              <td colspan="3">
                <p>distance</p>
              </td>
              <td>
                <p>string</p>
              </td>
              <td>
                <p>输入经纬度是否在AOI面之中</p>
              </td>
              <td>
                <p>
                  0， 代表在AOI内<br />其余整数代表距离AOI的距离
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <h3>
        <ul style="list-style-type:disc;list-style-position:inside;">
          <li>服务示例</li>
        </ul>
      </h3>
      <div class="service-example">
        <p>
          https://lbsapi.meituan.com/v1/location/regeo?key=&lt;用户的key&gt;&amp;location=116.328635,40.086087&amp;show_fields=
        </p>
      </div>
      <regeo />
    </div>
  </div>
</template>
<script>
import '@ss/mtd-vue/lib/theme2/anchor.css'
import '@ss/mtd-vue/lib/theme2/anchor-link.css'
import Anchor from '@/views/support/anchor/anchor.vue'
import AnchorLink from '@/views/support/anchor/anchor-link.vue'
import regeo from './Regeo.vue'
export default {
  components: {
    Anchor,
    AnchorLink,
    regeo
  },
  data() {
    return {}
  },
  methods: {}
}
</script>
<style lang="less" scoped>
@import '../document.less';

.title-wrap {
  // right: calc(50vw - 590px);
  // float: right;
  position: absolute;
  right: 0px;
  top: 100px;
  .mtd-anchor .mtd-anchor-link {
    font-size: 14px !important;
  }
}

/deep/.mtd-anchor-link-active .mtd-anchor-link-title {
  color: #a46e00 !important;
  font-weight: 600;
  font-family: PingFangSC-Semibold;
}
/deep/.title-wrap .mtd-anchor-ink-ball {
  background-color: #ffd100 !important;
}
/deep/ .mtd-anchor-link-title:hover {
  color: #a46e00;
  font-weight: 600;
  font-family: PingFangSC-Semibold;
}
</style>
